import PayMeCooperationPage from './PayMeCooperationPage';

export default PayMeCooperationPage;
